// "use strict";
Object.defineProperty(exports, "__esModule", {
  value: true,
});
if (process.env.NODE_ENV === "development") {
  exports.default = {
    panelURL: "https://localhost:3303/",

    baseURL: "http://localhost:3303/api",
    backendURL: "http://localhost:6700/api",
  };
} else {
  exports.default = {
    websiteURL: "https://panel.alphatargeting.com/",
    baseURL: "https://panel.alphatargeting.com/api",
    backendURL: "https://panel.alphatargeting.com/api",
  };
}
